<template>
  <div class="box--generic grid grid-cols-1 grid-rows-box-generic items-start">
    <h2 :class="headerClass">
      <slot name="header">{{ header }}</slot>
    </h2>
    <section
      :class="{ 'h-stretch': hStretch, 'w-stretch': wStretch }"
      class="supports-bg-filter:bg-saturate-blur"
    >
      <slot />
    </section>
  </div>
</template>

<script>
export default {
  name: "BoxGeneric",
  props: {
    header: {
      type: String,
      default: "",
    },
    hStretch: {
      type: Boolean,
      default: false,
    },
    wStretch: {
      type: Boolean,
      default: false,
    },
    headerClass: {
      type: String,
      default: "title-block",
    },
  },
};
</script>

<style scoped>
.grid-rows-box-generic {
  grid-template-rows: min-content minmax(0, 1fr);
}
</style>
